module.exports = (__webpack_require__(0))(89);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-utils/object.js from dll-reference rlink_core
// module id = 38
// module chunks = 0